import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { SaveProfileRequest } from '../create-user/master-create-user-model';

const BASE_PATH = environment.basePath;
const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root',
})
export class EditUserService {
  private urlpost = `${BASE_PATH}/bff/master/users/create`;

  constructor(private http: HttpClient) { }

  postForm(salvar: any): Observable<any> {
    if (salvar === null || salvar === undefined) {
      console.log('Salvar undefined');
      return;
    }
    return this.http.post<any>(`${this.urlpost}`, salvar, { headers: headers });
  }

  editUser(payload: any): Observable<any> {
    return this.http.post(`${BASE_PATH}/bff/master-bo/users/edit`, payload, {
      headers: headers,
    });
  }

  saveProfile(payload): Observable<any> {
    return this.http.post(
      //`${BASE_PATH}/bff/master-bo/users/create/profile/save/?clientId=${payload.institutionOwner.id}`,
      `${BASE_PATH}/bff/master-bo/users/edit/profile/save`,
      payload,
      { headers: headers },
    );
  }
}
